export function getSavedGeolocation(): google.maps.LatLngLiteral | null | undefined {
  const savedGeolocation = localStorage.getItem('savedGeolocation');
  return savedGeolocation ? JSON.parse(savedGeolocation) : undefined;
}

export function setSavedGeolocation(location: google.maps.LatLngLiteral | null) {
  localStorage.setItem('savedGeolocation', JSON.stringify(location));
}
